export const addJPCountryCode = (phoneNumber: string) => {
  const countryCode = '81';
  return countryCode.concat(phoneNumber.slice(1));
};

export const formatPhoneNumberDisplay = (phoneNumber: string) => {
  if (phoneNumber && phoneNumber.length === 11)
    return phoneNumber.slice(0, 3).concat('-').concat(phoneNumber.slice(3, 7)).concat('-').concat(phoneNumber.slice(7, 11));
  return '';
};

export const MAX_FILE_SIZE = 20 * 1024 * 1024;

export const FILE_DEFAULT_NAME = 'placeholder_9523FE5C-3A46-4DCD-9B89-C400A5F5E79C';

export const ALLOWED_FILE_EXTENSIONS = ['image/png', 'application/pdf', 'image/tiff', 'image/jpg', 'image/jpeg'];

export const VIEWABLE_FILES = ['image/png', 'image/jpg', 'image/jpeg'];

export const MAX_FILES_PER_DOCUMENT = 30;

export type ValueOf<T> = T[keyof T];
